import type { ReactNode } from "react";
import PageContainer from "./PageContainer";

/**
 * Секция страницы с единым вертикальным ритмом. Все публичные страницы должны
 * использовать её, чтобы отступы не гуляли от py-24 до нуля.
 *
 * tone="muted" — приглушённая полоса с границами сверху и снизу, для блоков,
 * которые нужно отделить от основного полотна.
 */
export default function PageSection({
  id,
  children,
  className = "",
  tone = "default",
  bleed = false,
}: {
  id?: string;
  children: ReactNode;
  className?: string;
  tone?: "default" | "muted";
  /** true — без внутреннего контейнера, если секция сама управляет шириной. */
  bleed?: boolean;
}) {
  const toneClass =
    tone === "muted" ? "border-y border-white/10 bg-white/[0.03]" : "";

  return (
    <section
      id={id}
      className={`scroll-mt-24 py-10 md:py-14 ${toneClass} ${className}`}
    >
      {bleed ? children : <PageContainer>{children}</PageContainer>}
    </section>
  );
}
